// ギフトオプションの連動制御
document.addEventListener('DOMContentLoaded', function() {
    
    // 商品ページのメインフォームを初期化
    if (document.querySelector('.product-form')) {
      initializeGiftOptions(document);
    }
  
    // product-gridがある場合（コレクションページまたは商品ページのrelated-products）
    const existingProductGrid = document.querySelector('.product-grid');
    if (existingProductGrid) {
      setupCollectionPageGiftOptions();
    }
    
    // related-productsの遅延ロードを監視（商品ページの場合）
    if (document.querySelector('.product-form')) {
      const bodyObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // 要素ノードの場合
              // 追加されたノード自体、または子孫に.product-gridがあるかチェック
              const hasProductGrid = node.classList && node.classList.contains('product-grid') ||
                                     node.querySelector && node.querySelector('.product-grid');
              
              if (hasProductGrid && !document.body.dataset.relatedProductsInitialized) {
                document.body.dataset.relatedProductsInitialized = 'true';
                setupCollectionPageGiftOptions();
                bodyObserver.disconnect();
              }
            }
          });
        });
      });
      
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }
    
    // どちらも検出されない場合
    if (!document.querySelector('.product-form') && !existingProductGrid) {
      initializeGiftOptions(document);
    }
  });
  
  // コレクションページのギフトオプション監視をセットアップ
  function setupCollectionPageGiftOptions() {
    
    const classObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          
          if (target.classList.contains('expanded') && target.classList.contains('product-block')) {
            handleQuickbuyGiftOptions(target);
          }
        }
      });
    });
  
    const productBlocks = document.querySelectorAll('.product-block');
    
    productBlocks.forEach(function(block, index) {
      classObserver.observe(block, { 
        attributes: true, 
        attributeFilter: ['class']
      });
      
      // 既に展開されている場合は即座に初期化
      if (block.classList.contains('expanded')) {
        handleQuickbuyGiftOptions(block);
      }
    });
  }
  
  // クイックバイのギフトオプションを処理
  function handleQuickbuyGiftOptions(block) {
    
    const quickbuyContainer = block.querySelector('.quickbuy-container');
    if (!quickbuyContainer) {
      return;
    }
    
    const inner = quickbuyContainer.querySelector('.inner');
    if (!inner) {
      return;
    }
  
    // 既に初期化済みの場合はスキップ
    if (quickbuyContainer.dataset.giftOptionsInitialized) {
      return;
    }
    
    let initAttempts = 0;
    const maxAttempts = 10;
    
    const contentObserver = new MutationObserver(function(mutations) {
      const hasContent = mutations.some(m => 
        m.addedNodes.length > 0 || 
        (m.target.nodeType === 1 && m.target.children.length > 0)
      );
      
      if (hasContent && initAttempts < maxAttempts) {
        initAttempts++;
        const success = initializeGiftOptions(inner);
        
        if (success) {
          contentObserver.disconnect();
          quickbuyContainer.dataset.giftOptionsInitialized = 'true';
        }
      }
    });
  
    contentObserver.observe(inner, { childList: true, subtree: true });
    
    // 初回試行
    const success = initializeGiftOptions(inner);
    if (success) {
      quickbuyContainer.dataset.giftOptionsInitialized = 'true';
    } else {
      console.log('[Gift Options] Initial attempt failed, waiting for mutations');
    }
  }
  
  // ギフトオプションの初期化（戻り値: 成功したかどうか）
  function initializeGiftOptions(container) {
    
    // 必須のオプションがすべて存在するかチェック
    const hasRibbonOption = container.querySelector('fieldset[data-option="リボン掛け"]');
    const hasNoshiOption = container.querySelector('fieldset[data-option="熨斗"]');
    const hasMizuhikiOption = container.querySelector('fieldset[data-option="水引き"]');
  
    if (!hasRibbonOption || !hasNoshiOption || !hasMizuhikiOption) {
      return false; // 必須オプションがなければ失敗
    }
  
    // 各オプションのラジオボタンを取得
    const ribbonInputs = container.querySelectorAll('input[name*="リボン掛け-option"]');
    const noshiInputs = container.querySelectorAll('input[name*="熨斗-option"]');
    const mizuhikiInputs = container.querySelectorAll('input[name*="水引き-option"]');
  
    // 「熨斗不要」のラジオボタンを取得
    const noshiNotNeeded = Array.from(noshiInputs).find(input => 
      input.value === '熨斗不要'
    );
    const mizuhikiNotNeeded = Array.from(mizuhikiInputs).find(input => 
      input.value === '熨斗不要'
    );
  
    // 熨斗と水引きのfieldsetを取得
    const noshiFieldset = container.querySelector('fieldset[data-option="熨斗"]');
    const mizuhikiFieldset = container.querySelector('fieldset[data-option="水引き"]');
  
    // オプションを無効化する関数
    function disableOptions(inputs, fieldset) {
      inputs.forEach(input => {
        input.disabled = true;
        const label = container.querySelector(`label[for="${input.id}"]`);
        if (label) {
          label.style.opacity = '0.5';
          label.style.cursor = 'not-allowed';
          label.style.pointerEvents = 'none';
        }
      });
    }
  
    // オプションを有効化する関数
    function enableOptions(inputs, fieldset) {
      inputs.forEach(input => {
        input.disabled = false;
        const label = container.querySelector(`label[for="${input.id}"]`);
        if (label) {
          label.style.opacity = '1';
          label.style.cursor = 'pointer';
          label.style.pointerEvents = 'auto';
        }
      });
    }
  
    // 1&2: リボン掛けの変更イベント
    ribbonInputs.forEach(input => {
      input.addEventListener('change', function() {
        
        if (this.value === '箱＋リボン掛け') {
          // 熨斗と水引きを「熨斗不要」に設定
          if (noshiNotNeeded) noshiNotNeeded.checked = true;
          if (mizuhikiNotNeeded) mizuhikiNotNeeded.checked = true;
          
          // 熨斗と水引きを無効化
          disableOptions(noshiInputs, noshiFieldset);
          disableOptions(mizuhikiInputs, mizuhikiFieldset);
        } else if (this.value === '箱のみ') {
          // 熨斗と水引きを有効化
          enableOptions(noshiInputs, noshiFieldset);
          enableOptions(mizuhikiInputs, mizuhikiFieldset);
        }
      });
    });
  
    // 3: 熨斗オプションの変更イベント
    noshiInputs.forEach(input => {
      input.addEventListener('change', function() {
        if (this.value === '熨斗不要' && mizuhikiNotNeeded) {
          // 熨斗不要が選択された場合、水引きも熨斗不要にする
          mizuhikiNotNeeded.checked = true;
        } else {
          // 熨斗不要以外が選択された場合、水引きが熨斗不要なら紅白蝶結びに切り替え
          const mizuhikiKouhakuChoumusubi = Array.from(mizuhikiInputs).find(input => 
            input.value === '紅白蝶結び'
          );
          if (mizuhikiNotNeeded && mizuhikiNotNeeded.checked && mizuhikiKouhakuChoumusubi) {
            mizuhikiKouhakuChoumusubi.checked = true;
          }
        }
      });
    });
  
    // 4: 水引きオプションの変更イベント
    mizuhikiInputs.forEach(input => {
      input.addEventListener('change', function() {
        if (this.value === '熨斗不要' && noshiNotNeeded) {
          noshiNotNeeded.checked = true;
        } else {
          // 熨斗不要以外が選択された場合、熨斗が熨斗不要なら無地に切り替え
          const noshiMuji = Array.from(noshiInputs).find(input => 
            input.value === '無地'
          );
          if (noshiNotNeeded && noshiNotNeeded.checked && noshiMuji) {
            noshiMuji.checked = true;
          }
        }
      });
    });
  
    // 初期状態のチェック(ページ読み込み時に「箱＋リボン掛け」が選択されている場合)
    const selectedRibbon = Array.from(ribbonInputs).find(input => input.checked);
    if (selectedRibbon && selectedRibbon.value === '箱＋リボン掛け') {
      if (noshiNotNeeded) noshiNotNeeded.checked = true;
      if (mizuhikiNotNeeded) mizuhikiNotNeeded.checked = true;
      disableOptions(noshiInputs, noshiFieldset);
      disableOptions(mizuhikiInputs, mizuhikiFieldset);
    }
    
    return true; // 初期化成功
  }